/**
 * 순수 포맷/계산 유틸 (컴포넌트 의존 없음)
 */
import dayjs from "dayjs";

/** 1,234,567원 — 원화 통화 포맷 */
export const currency = (price?: number | null): string =>
  `${Math.floor(price || 0).toLocaleString("ko-KR")}원`;

/** 양수/음수 부호 포함 통화 (+12,300원 / -45,000원) */
export const signedCurrency = (price?: number | null): string =>
  `${price && price > 0 ? "+" : ""}${currency(price)}`;

/** 컴팩트 통화 — Statistic 카드용 (7.6억 / 7,597만) — 만원 미만은 반올림해 소수점 미노출 */
export const formatWon = (v: number): string => {
  if (Math.abs(v) >= 1e8) return `${(v / 1e8).toFixed(1)}억`;
  if (Math.abs(v) >= 1e4) return `${Math.floor(v / 1e4).toLocaleString()}만`;
  return Math.round(v).toLocaleString("ko-KR");
};

export const formatWonFull = (v: number): string => `${Math.round(v).toLocaleString("ko-KR")}원`;

/** 수익/손실 컬러 (한국 컨벤션: 상승=빨강) */
export const pnlColor = (value: number): string =>
  value > 0 ? "var(--fred)" : value < 0 ? "var(--fblue)" : "#faad14";

export const getFormatedDate = (date: string | Date, pattern: string): string =>
  dayjs(date).format(pattern);

/** 계좌/카드명 태그 색상 (인덱스 기반 순환) */
export const tagColorByIndex = (name: string, allNames: string[]): string => {
  const palette = [
    "geekblue",
    "volcano",
    "orange",
    "green",
    "purple",
    "cyan",
    "magenta",
    "gold",
  ];
  return palette[Math.max(0, allNames.indexOf(name)) % palette.length];
};
